<template>
    <div>
        <select ref="select2Element"
                class="form-control"
                :id="id"
                :name="name"
                :disabled="disabled"
                :required="required"
        ></select>
    </div>
</template>


<script>
import $ from 'jquery';
import 'select2/dist/js/select2.full.min';
import {computed, onMounted, onUnmounted, ref, watch} from "vue";

export default {
    name: "SelectTwo",
    props: {
        id: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        options: {
            type: Array,
            default: () => []
        },
        disabled: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        settings: {
            type: Object,
            default: () => {}
        },
        modelValue: {
            type: String,
            default: null
        },
        searchPlaceholder: {
            type: String,
            default: '',
        }
    },
    setup(props, {emit}) {
        let select2 = null;
        const select2Element = ref(null);

        const setOption = (val = []) => {
            select2.empty();
            select2.select2({
                placeholder: props.placeholder,
                ...props.settings,
                data: val
            });
        };

        const setValue = (val) => {
            if (val instanceof Array) {
                select2.val([...val]);
            } else {
                select2.val([val]);
            }
            select2.trigger('change');
        }

        const init = () => {
            select2 = $(select2Element.value)
                .select2({
                    placeholder: props.placeholder,
                    ...props.settings,
                    data: props.options
                })
                .on('select2:select select2:unselect', ev => {
                    selectedValue.value = select2.val();
                    emit('change', select2.val());
                    emit('select', ev['params']['data']);
                })
                .on('select2:closing', ev => {
                    if (props.searchPlaceholder.length) {
                        $(".select2-search--dropdown .select2-search__field")
                            .attr("placeholder", props.placeholder);
                    }
                    emit('closing', ev);
                })
                .on('select2:close', ev => {
                    emit('close', ev);
                })
                .on('select2:opening', ev => {
                    emit('opening', ev);
                })
                .on('select2:open', ev => {
                    if (props.searchPlaceholder.length) {
                        $(".select2-search--dropdown .select2-search__field")
                            .attr("placeholder", props.searchPlaceholder)[0].focus();
                    }
                    emit('open', ev);
                })
                .on('select2:clearing', ev => {
                    emit('clearing', ev);
                })
                .on('select2:clear', ev => {
                    emit('clear', ev);
                });
            setOption(props.options);
            setValue(selectedValue.value);
        };

        onMounted(init);

        const selectedValue = computed({
            get: () => props.modelValue,
            set: (value) => emit('update:modelValue', value),
        })

        watch(selectedValue, (val) => setValue(val))

        onUnmounted(() => {
            select2.select2('destroy');
        });

        return {
            select2Element,
            selectedValue
        }
    },
}
</script>

<style scoped>

</style>
